import React from 'react';
import { isProceduralBackground, getProceduralKey } from '../proceduralBackgrounds';
import ProceduralBackground from '../ProceduralBackground';

/**
 * Canonical background positioning so start/end and in-game backgrounds match
 * when the same image is used (seamless transition into the game).
 * Use this for any full-screen static background (start, end, or in-game).
 */
export const BACKGROUND_COVER_POSITION = {
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};

/**
 * Background layer for start and end screens only.
 * Uses options.backgroundImage with cover sizing, or fallback color.
 * In-game backgrounds should use BACKGROUND_COVER_POSITION so the same image lines up.
 */
const StartEndBackground = React.memo(({ backgroundImage, backgroundColor, direction }) => {
  const defaultColor = backgroundColor || '#87CEEB';
  if (isProceduralBackground(backgroundImage)) {
    return <ProceduralBackground rendererKey={getProceduralKey(backgroundImage)} style={{ zIndex: 0 }} direction={direction} />;
  }
  if (!backgroundImage) {
    return (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          backgroundColor: defaultColor,
        }}
      />
    );
  }
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        backgroundImage: `url(${backgroundImage})`,
        ...BACKGROUND_COVER_POSITION,
      }}
    />
  );
});

StartEndBackground.displayName = 'StartEndBackground';

export default StartEndBackground;
